import { formatToUniversalDateTime } from 'utils/dates';

export interface CounterOutput {
  lotid: string;
  quant: number;
  station: string;
  timestamp: string;
}

export interface MessageLogEntry {
  timestamp?: string;
  rawMessage: string;
  parsedMessage?: CounterOutput;
  error?: string;
}

export enum CounterMessageErrorType {
  INVALID_JSON = 'Invalid JSON format',
  INVALID_MESSAGE = 'Invalid message format',
  EMPTY_MESSAGE = 'Empty message received',
}

export class CounterMessageError extends Error {
  constructor(message: string, public rawMessage: string) {
    super(message);
    this.name = 'CounterMessageError';
  }
}

export const validateCounterOutput = (data: unknown): data is CounterOutput => {
  if (!data || typeof data !== 'object') return false;

  const candidate = data as Partial<CounterOutput>;
  return (
    typeof candidate.lotid === 'string' &&
    typeof candidate.quant === 'number' &&
    typeof candidate.station === 'string' &&
    typeof candidate.timestamp === 'string' &&
    candidate.lotid.length > 0
  );
};

export const parseSerialMessage = (message: string): CounterOutput => {
  if (!message.trim()) {
    throw new CounterMessageError(
      CounterMessageErrorType.EMPTY_MESSAGE,
      message
    );
  }

  let parsed: unknown;
  try {
    parsed = JSON.parse(message);
  } catch (e) {
    throw new CounterMessageError(
      CounterMessageErrorType.INVALID_JSON,
      message
    );
  }

  if (!validateCounterOutput(parsed)) {
    throw new CounterMessageError(
      CounterMessageErrorType.INVALID_MESSAGE,
      message
    );
  }

  return parsed;
};

export const createMessageLogEntry = (
  rawMessage: string,
  parsedMessage?: CounterOutput,
  error?: string
): MessageLogEntry => ({
  timestamp: formatToUniversalDateTime(new Date()),
  rawMessage,
  parsedMessage,
  error,
});
